import { combineReducers } from "redux";
import { createItemReducer } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function aboutMeReducer() {
    return combineReducers({
        ListForPODesc1: createItemReducer("PaHome", "PersonalCard.ListForNewPODesc1", false),
        ListGenForPO: createItemReducer("PaHome", "PersonalCard.ListGenForNewPO", false),
        ListGenForPO_Slavutich: createItemReducer("PaHome", "PersonalCard.ListGenForNewPOSlav", false),
        ListForPODesc2: createItemReducer("PaHome", "PersonalCard.ListForNewPODesc2", false),
        TreeForNewPO: createItemReducer("PaHome", "PersonalCard.TreeForNewPO", false)
    });
}